var $c73bcadfc547eb5a$exports = {};
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{
    const nameTextField = document.getElementById("nameTextField");
    const subjectTextField = document.getElementById("subjectTextField");
    const messageTextField = document.getElementById("messageTextField");
    const sendContactButton = document.getElementById("sendContactButton");
    $("#contactForm").submit(()=>{
        return false;
    });
    sendContactButton.addEventListener('click', ()=>{
        const name = nameTextField.value;
        const subject = subjectTextField.value;
        const message = messageTextField.value;
        var error = "";
        if (name == "") error = "Name is required";
        if (subject == "") error = "Subject is Required";
        if (message == "") error = "Message is required";
        if (error != "") alert(error);
        else launchEmailSender("repscoachsoto@gmail.com", name + " - " + subject, message);
    });
    function launchEmailSender(recipientEmail, subject, body) {
        document.location = "mailto:" + recipientEmail + "?subject=" + subject + "&body=" + body;
    }
});


//# sourceMappingURL=REPS-Soccer.6a6e4cd9.js.map
